@let showIdentityCard =
	recordData().driverIdentityDocumentNumber ||
	recordData().driverIdentityDocumentType ||
	recordData().driverIdentityDocumentIssuedByCountryId ||
	recordData().driverIdentityDocumentIssueDate ||
	recordData().driverIdentityDocumentExpiryDate;

@let showDrivingLicense =
	recordData().driverDrivingLicenseNumber ||
	recordData().driverDrivingLicenseCategory ||
	recordData().driverDrivingLicenseIssuedByCountryId ||
	recordData().driverDrivingLicenseIssueDate ||
	recordData().driverDrivingLicenseExpiryDate;

<app-section-wrapper-container [title]="'driver-card|title'">
	<div class="flex flex-col md:flex-row gap-4">
		@if (showIdentityCard) {
			<div class="overview-sub-section">
				<ng-container [ngTemplateOutlet]="idTitle"></ng-container>
				@if (recordData().driverIdentityDocumentNumber) {
					<app-summary-item
						[title]="
							'customers|record|driver-section|field-label|identity-document-number'
						"
						[value]="recordData().driverIdentityDocumentNumber" />
				}
				@if (recordData().driverIdentityDocumentType) {
					<app-summary-item
						[title]="
							'customers|record|driver-section|dropdown-label|identity-document-type'
						"
						[value]="
							recordData().driverIdentityDocumentType
								| getTranslationKeyFromValue: idTypes
								| transloco
						" />
				}
				@if (recordData().driverIdentityDocumentIssuedByCountryId) {
					<app-summary-item
						[title]="
							'customers|record|driver-section|dropdown-label|identity-document-issued-by-country'
						"
						[value]="
							recordData().driverIdentityDocumentIssuedByCountryId | countryName
						" />
				}
				@if (recordData().driverIdentityDocumentIssueDate) {
					<app-summary-item
						[title]="
							'customers|record|driver-section|field-label|identity-document-issue-date'
						"
						[value]="
							recordData().driverIdentityDocumentIssueDate | date: 'dd MMM yyyy'
						" />
				}
				@if (recordData().driverIdentityDocumentExpiryDate) {
					<app-summary-item
						[title]="
							'customers|record|driver-section|field-label|identity-document-expiry-date'
						"
						[value]="
							recordData().driverIdentityDocumentExpiryDate
								| date: 'dd MMM yyyy'
						" />
				}
			</div>
		} @else {
			<div class="overview-sub-section">
				<ng-container [ngTemplateOutlet]="idTitle"></ng-container>

				<div class="summary-item-wrapper subtle-text py-7">
					{{ 'shared|none' | transloco }}
				</div>
			</div>
		}
		@if (showDrivingLicense) {
			<div class="overview-sub-section">
				<ng-container [ngTemplateOutlet]="drivingLicenseTitle"></ng-container>

				@if (recordData().driverDrivingLicenseNumber) {
					<app-summary-item
						[title]="
							'customers|record|driver-section|field-label|driving-license-number'
						"
						[value]="recordData().driverDrivingLicenseNumber" />
				}

				@if (recordData().driverDrivingLicenseCategory) {
					<app-summary-item
						[title]="
							'customers|record|driver-section|field-label|driving-license-category'
						"
						[value]="recordData().driverDrivingLicenseCategory" />
				}

				@if (recordData().driverDrivingLicenseIssuedByCountryId) {
					<app-summary-item
						[title]="
							'customers|record|driver-section|dropdown-label|driving-license-issued-by-country'
						"
						[value]="
							recordData().driverDrivingLicenseIssuedByCountryId | countryName
						" />
				}

				@if (recordData().driverDrivingLicenseIssueDate) {
					<app-summary-item
						[title]="
							'customers|record|driver-section|field-label|driving-license-issue-date'
						"
						[value]="
							recordData().driverDrivingLicenseIssueDate | date: 'dd MMM yyyy'
						" />
				}

				@if (recordData().driverDrivingLicenseExpiryDate) {
					<app-summary-item
						[title]="
							'customers|record|driver-section|field-label|driving-license-expiry-date'
						"
						[value]="
							recordData().driverDrivingLicenseExpiryDate | date: 'dd MMM yyyy'
						" />
				}
			</div>
		} @else {
			<div class="overview-sub-section">
				<ng-container [ngTemplateOutlet]="drivingLicenseTitle"></ng-container>

				<div class="summary-item-wrapper subtle-text py-7">
					{{ 'shared|none' | transloco }}
				</div>
			</div>
		}
	</div>
</app-section-wrapper-container>

<ng-template #idTitle>
	<h5 class="p-4 px-6 font-medium">
		{{ 'shared|identity-card|title' | transloco }}
	</h5>
</ng-template>

<ng-template #drivingLicenseTitle>
	<h5 class="p-4 px-6 font-medium">
		{{ 'shared|driving-license|title' | transloco }}
	</h5>
</ng-template>
